import { Container } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import consultants from "../../../.sourceflow/consultants.json";

const mapConsultant = (v) => ({
  name: v?.name?.en ?? "",
  role: v?.position_title?.en ?? "",
  imageUrl: v?.profile_image?.en ?? "",
  hideOnTeamPage: v?.hide_on_team_page?.en === true || v?.hide_on_team_page?.en === "true",
  showOnAboutPage: v?.show_on_about_page?.en === true || v?.show_on_about_page?.en === "true",
});

export const MeetTheTeam = ({
  title = "Meet the team",
  description,
  aboutOnly = false,
  excludeHidden = true,
  maxItems = 12,
  ctaText = "Join the team",
  ctaHref = "",
  className = "",
}) => {
  const source = Array.isArray(consultants?.category_values) ? consultants.category_values : [];

  let people = source.map(mapConsultant);

  if (excludeHidden) {
    people = people.filter((p) => !p.hideOnTeamPage);
  }
  if (aboutOnly) {
    people = people.filter((p) => p.showOnAboutPage);
  }

  if (Number.isFinite(maxItems) && maxItems > 0) {
    people = people.slice(0, maxItems);
  }

  return (
    <section className={cn(styles.MeetTheTeam, className)}>
      <Container>
        <div className={styles.header}>
          {title && <h3 className={styles.subtitle}>{title}</h3>}
          {description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />}
        </div>

        <div className={styles.grid}>
          <div className={styles.rowTwo}>
            {people.slice(0, 2).map((m, idx) => (
              <div key={idx} className={styles.card}>
                <div className={styles.imageWrapper}>
                  {m.imageUrl && (
                    <img src={m.imageUrl} alt={m.name || "Team member"} className={styles.image} loading="lazy" />
                  )}
                  <div className={styles.overlay}>
                    {m.name && <div className={styles.name}>{m.name}</div>}
                    {m.role && (
                      <div className={styles.roleWrapper}>
                        <span className={styles.dot} />
                        <span className={styles.role}>{m.role}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className={cn(people.slice(2, 5).length === 2 ? styles.rowTwo : styles.rowThree)}>
            {people.slice(2, 5).map((m, idx) => (
              <div key={idx + 2} className={styles.card}>
                <div className={styles.imageWrapper}>
                  {m.imageUrl && (
                    <img src={m.imageUrl} alt={m.name || "Team member"} className={styles.image} loading="lazy" />
                  )}
                  <div className={styles.overlay}>
                    {m.name && <div className={styles.name}>{m.name}</div>}
                    {m.role && (
                      <div className={styles.roleWrapper}>
                        <span className={styles.dot} />
                        <span className={styles.role}>{m.role}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {ctaText &&
          (ctaHref ? (
            <a href={ctaHref} className={styles.cta}>
              <span>{ctaText}</span>
            </a>
          ) : (
            <div className={styles.cta}>
              <span>{ctaText}</span>
            </div>
          ))}
      </Container>
    </section>
  );
};

export default MeetTheTeam;
